import { UIComponent } from "../../components";
import { Collapse } from "bootstrap";

export class ModalAccordion extends UIComponent {
    init() {
        this.id = this.btn.id;
        this.collapseInst = new Collapse(this.collapseEl.element, { parent: this.parent.element, toggle: false });
        this.btn.on('click', this.toggleView.bind(this));
        this.on('hide.bs.collapse', this.handleHide.bind(this));
        this.on('show.bs.collapse', this.handleShow.bind(this));
    }

    toggleView() {
        this.collapseInst.toggle();
    }

    handleShow() {
        this.addClass('modal-ai-templates__accordion--show');
        this.emit('activeAccordion', { id: this.id }, { bubbles: true });
    }

    handleHide() {
        this.removeClass('modal-ai-templates__accordion--show');
    }
}
